import { render, staticRenderFns } from "./gclick-fluxo-select.vue?vue&type=template&id=53291c75"
import script from "./gclick-fluxo-select.vue?vue&type=script&lang=js"
export * from "./gclick-fluxo-select.vue?vue&type=script&lang=js"
import style0 from "./gclick-fluxo-select.vue?vue&type=style&index=0&id=53291c75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports